import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { installTarslogs } from './plugins/tarslogs'
import './assets/main.css'

const app = createApp(App)
app.use(router)
installTarslogs(app)
app.mount('#app')
